// extracted by mini-css-extract-plugin
export default {"facetMenu":"Tu-z","fixed":"Uu-z","nonLayerdFacets":"Vu-z","productCount":"Wu-z","facetBack":"Xu-z","arrow":"Yu-z","facetClose":"Zu-z"};